export default __webpack_public_path__ + "static/media/thop-apontando.7c7d6b63.png";